import React, { ReactElement } from 'react';
import Card from '../card/card.component';
import Button from '../button/button.component';
import ModalButtonBlock from '../modal-button-block/modal-button-block.component';
import ErrorBlock from '../error-block/error-block.component';
import ModalLayout from '../modal-layout/modal-layout.component';

const ConfirmModal: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const LABEL_CONFIRM_DEFAULT: string = 'Confirm';

  const {
    isOpen,
    isSubModal,
    title,
    text,
    confirmText,
    errorMessage,
    onConfirm,
    onCloseModal,
  } = props;

  const confirm: MouseEventHandlerFunction = (): void => {
    if (onConfirm) {
      onConfirm();
    } else if (onCloseModal) {
      onCloseModal();
    }
  };

  return (
    <ModalLayout isOpen={isOpen} isSubModal={isSubModal} title={title} onCloseModal={onCloseModal}>
      <Card isContainer>
        {text}
      </Card>
      <ModalButtonBlock>
        <Button onClick={onCloseModal}>
          Cancel
        </Button>
        <Button isActive onClick={confirm}>
          {confirmText || LABEL_CONFIRM_DEFAULT}
        </Button>
      </ModalButtonBlock>
      {
        !!errorMessage && (
          <ErrorBlock errorMessage={errorMessage} />
        )
      }
    </ModalLayout>
  );
});

export default ConfirmModal;
